import { DocumentNode } from 'graphql'
import { withProps } from '../../utils/components'

const withMutation = (mutation: DocumentNode) => withProps({ mutation })

export default withMutation



// WEBPACK FOOTER //
// ./src/components/mutations/withMutation.tsx